module.exports = __webpack_public_path__ + "static/p-logo--ecbeing-1013514ea6dee638de4f27df43fbc9c4.png";